import { toURLSearchParams } from '@wix/metro-runtime';
import { resolveUrl } from '@wix/metro-runtime';
function resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl(opts) {
    const domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/availability-calendar',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v2/availability/schedule',
                destPath: '/v2/availability/schedule',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/bookings/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/bookings/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Retrieves the availability for sessions
 * that match the provided query criteria (paging, filtering, and sorting).
 *
 *
 * The Availability Calendar APIs calculate the availability of sessions for
 * appointments and classes, but not
 * for courses.
 *
 * The entire list of slots is returned in case you want to display both
 * available and non-available slots in the calendar for your customers.
 * Using the `bookable` property, you can limit the display to available
 * slots only.
 *
 * When querying, you must enter a start date and an end date. This avoids very large
 * results that can impact performance.
 *
 * #### Calculating availability
 *
 * The availability is determined
 * by checking:
 * + **The sessions' open slots**. A slot is considered open if the session's
 * capacity is greater than number of participants.
 * + **Booking policies**. Policies that affect whether a slot is considered
 * available include `tooEarlyToBook`, `tooLateToBook`, and `bookOnlineDisabled`.
 *
 * Locked sessions do not impact session availability and `bookable` can
 * be `true` even if `locked` is `true`. For example, if a session has a waitlist and a
 * place frees up, the slot is offered to the customers on the waitlist, one by one. The
 * session remains locked because there is still a waitlist, but for a period of time
 * there is availability, until a customer on the waitlist takes the slot. Locking
 * prevents customers who are not yet on the waitlist from grabbing the slot.
 *
 * #### Handling Daylight Savings Time (DST) for local time zones
 *
 * Because of DST, there are cases where certain times either do not exist
 * or exist twice for a local time zone.
 * For example, the tine `00:05` on September 5th 2021 might not exist in Santiago, Chile,
 * because at `00:00` the clock moved
 * 1 hour forward to `01:00`.
 *
 * In this case, the Availability Calendar APIs take this
 * into account and mediate the time gaps automatically. The non-existent local time is
 * automatically moved forward 1 hour to match local DST. Local times that exist do not change.
 * So if the `queryAvailability()` function is called with a `startDate` of `2021-09-05T00:00:01.000`
 * and an `endDate` of `2021-09-06T00:00:02.000`, `2021-09-05T01:00:01.000` is used in the query
 * instead. The start time shifts one hour forward and the end time remains the same.
 */
export function queryAvailability(payload) {
    function __queryAvailability({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.QueryAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/availability/query',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __queryAvailability;
}
/**
 * Returns availability for a given schedule ID
 * The availability for a course is calculated by:
 * - Checking for total spots by the schedule's capacity
 * - Checking for open spots by subtracting the current number of participants from the total spots
 * current number of participants is calculated by summing the number of participants of all bookings booked to the schedule
 */
export function getScheduleAvailability(payload) {
    function __getScheduleAvailability({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetScheduleAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v2/availability/schedule/{scheduleId}',
                data: payload,
                host,
            }),
            params: toURLSearchParams(payload),
        };
        return metadata;
    }
    return __getScheduleAvailability;
}
export function calculateMultiSlotAvailability(payload) {
    function __calculateMultiSlotAvailability({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.CalculateMultiSlotAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/availability/multislot',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __calculateMultiSlotAvailability;
}
//# sourceMappingURL=bookings-availability-v1-slot-availability-availability-calendar.http.js.map